import React from 'react';
import PropTypes from 'prop-types';

export default function FloatingTooltip({
  title,
  minWidth,
  onMouseEnter,
  onMouseLeave,
  omitArrow,
  arrowOffset,
  setRef
}) {
  return (
    <span
      style={ { minWidth } }
      className="FloatingTooltip bg-black-70 br2 ph4 pv2 white f2 dib bg-blur-2"
      onMouseEnter={ onMouseEnter }
      onMouseLeave={ onMouseLeave }
      ref={ setRef }
    >
      {
        !omitArrow &&
          <span
            style={ { left: `calc(50% - ${arrowOffset}px)` } }
            className="FloatingTooltip__arrowContainer br-100 overflow-hidden pointer-events-none transform-center-x"
          >
            <span className="FloatingTooltip__arrow w0 h0 absolute" />
          </span>
      }
      { title }
    </span>
  );
}

FloatingTooltip.propTypes = {
  title: PropTypes.node.isRequired,
  minWidth: PropTypes.string.isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  omitArrow: PropTypes.bool,
  setRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  arrowOffset: PropTypes.number
};

FloatingTooltip.defaultProps = {
  onMouseEnter: () => null,
  onMouseLeave: () => null,
  omitArrow: false,
  setRef: null,
  arrowOffset: 0
};

